import React from "react";
import OtpContainerOrder from "../components/Otp/OtpContainerOrder";

type Props = {};

const Otp = (props: Props) => {
  return (
    <div className="page">
      <OtpContainerOrder />
    </div>
  );
};

export default Otp;
